module.exports = __webpack_public_path__ + "static/img/dh.892db53e.png";